import { useEffect } from 'react';

export function StructuredData() {
  useEffect(() => {
    const softwareSchema = {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'Quick Free Invoice Tool',
      alternateName: ['QuickFreeInvoice', 'Quick Free Invoice Generator', 'Quick Free Invoice'],
      applicationCategory: 'BusinessApplication',
      applicationSubCategory: 'Invoicing & Billing Software',
      description: 'Quick Free Invoice Tool is a free online invoice generator for creating, managing, and tracking professional PDF & Word invoices.',
      operatingSystem: 'Web Browser',
      url: 'https://quickfreeinvoicetool.com',
      image: 'https://quickfreeinvoicetool.com/og-image.png',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock',
      },
      author: {
        '@type': 'Organization',
        name: 'Quick Free Invoice Tool',
        alternateName: ['QuickFreeInvoice'],
        url: 'https://quickfreeinvoicetool.com',
        logo: 'https://quickfreeinvoicetool.com/favicon.png',
        sameAs: [
          'https://www.facebook.com/QuickFreeInvoiceTool',
          'https://twitter.com/quickfreeinvoice'
        ],
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'support@quickfreeinvoicetool.com',
          contactType: 'Customer Support',
        },
      },
      featureList: [
        'Create professional invoices',
        'Download as PDF and Word',
        'Convert quotations to invoices in one click',
        'Client management and read receipts',
        'Payment tracking',
        'Multiple currencies (170+)',
        'VAT, GST, and SST tax calculations',
      ],
    };

    const websiteSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Quick Free Invoice Tool',
      alternateName: ['QuickFreeInvoice', 'Quick Free Invoice Generator'],
      url: 'https://quickfreeinvoicetool.com',
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify([softwareSchema, websiteSchema]);
    script.id = 'structured-data';
    
    // Remove existing structured data if any
    const existing = document.getElementById('structured-data');
    if (existing) {
      existing.remove();
    }
    
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById('structured-data');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return null;
}
